import Header from "./sub-components/Header";
import '../../../src/styles/upgrade.css'
import { Button } from "@mui/material";
import { db } from './firebase/firebase';
import {useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import queryString from 'query-string';
import { de_encrypt } from "../../encryption";
import { doc, setDoc, getDocs, collection,getDoc ,query, addDoc, where, updateDoc } from "firebase/firestore";
const GetAccount = () => {
  const url= queryString.parse(window.location.search);
    const navigate = useNavigate();
    const user_key =de_encrypt(localStorage.getItem('user-key'));
     const [error,setError]=useState('');
     const [clicked,setClicked]=useState(false);
     const [accountNumber, setAnum]=useState(null);
     const [accountName,setAname]=useState(null);
     const [bankName,setBname]=useState(null);
    // const userRef=collection(db,"user");
    const make_edit = url.status == 'edit' ? true : false;
     const update_account = async ()=>{
         setClicked(true);
          setError('');
        if(accountNumber != null && accountName != null &&  bankName!=null){
         const userRef = doc(db, "user", user_key);
         const data = {
            acct_num:accountNumber,
            acct_name:accountName,
            bank_name:bankName
         }     
           await updateDoc(userRef, data); 
           setClicked(false);
           navigate('/withdraw') 
           
         }else{
           setError('Please fill all fields to proceed');
         }  
     }
    return ( 
        <div className="dashboard upgrade-container">
            <Header />
            <div className="base-nav">
                <div className="container">
                    <div className="scroll-wrapper">
                        <nav>
                            <a href="#">Overview</a>
                            <a href="#">Mine</a>
                            <a href="#">Referals</a>
                            <a href="#">Share & Earn</a>
                            <a href="#" className="active">Withdraw</a>
                            <a href="#">Marketplace</a>
                            <a href="#" >Notifications</a>
                            <a href="#">Upgrade</a>
                        </nav>
                    </div>

                </div>
            </div>
            {/* <div className="upgrade-box"> */}
              <div className="gc-box">
                   {!make_edit && <span>It seems this is your first withdrawal, Input your Account details to proceed</span> }
                    <div className="text-field">
                      <input type="text" placeholder='Enter Account Name' value={accountName} onChange={(e)=>{setAname(e.target.value)}} />
                    </div>
                    <div className="text-field">
                      <input type="number" placeholder='Enter Account Number' value={accountNumber} onChange={(e)=>{setAnum(e.target.value)}} />
                    </div>
                    <div className="text-field">
                      <input type="text" placeholder='Enter Bank Name' value={bankName} onChange={(e)=>{setBname(e.target.value)}} />
                    </div>
                    { !clicked &&  <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} onClick={update_account}> Proceed</Button>   
                    </div>}
                   
                  {clicked && <div className="btn">
                        <Button variant="contained" style={{backgroundColor:"#9900EF"}} > Processing</Button>   
                    </div> }
                  <p style={{color:"red",transform:"translateY(2em)",fontSize:"13px"}}>{error}</p>
                </div>
               
            {/* </div> */}
            
        </div> 
     );
}
 
export default GetAccount;
